module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hant/3-6573e7e703ca64d930ac92b7d3cb9b5f.jpg";